export const ENTITY_PATH = 'account_statistics/payment_page/v1';
